import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/analytics'
import 'firebase/performance'
import 'firebase/functions'

/** Build settings (cms/.env.example); nothing is built in, so a missing one fails loudly instead of using another project. */
function setting(name: string): string {
  const value = process.env[name];
  if (!value) throw new Error(`${name} is not set; see cms/.env.example.`);
  return value;
}

const config = {
  apiKey: setting('VUE_APP_FIREBASE_API_KEY'),
  authDomain: setting('VUE_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: setting('VUE_APP_FIREBASE_PROJECT_ID'),
  storageBucket: setting('VUE_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: setting('VUE_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: setting('VUE_APP_FIREBASE_APP_ID'),
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || undefined,
};


firebase.default.initializeApp(config);

// Analytics only with a measurement id (production).
if (config.measurementId) {
  firebase.default.analytics();
  firebase.default.performance();
}

const firestore = firebase.default.firestore
const auth = firebase.default.auth
const storage = firebase.default.storage
const app = firebase.default.app;
const functions = firebase.default.app().functions('europe-west1')

export {
  firestore,
  storage,
  auth,
  app,
  functions
}